import glightbox from "glightbox";

let glightboxInstances = [];

export default {
    init: function () {
        glightboxInstances = [
            ...glightboxInstances,
            glightbox({
                autoplayVideos: true
            })
        ];
    },
    cleanup: function () {
        glightboxInstances.forEach((lightbox) => lightbox.destroy());
        glightboxInstances = [];
    }
};
